export default 'webkitTransition' in document.head.style ? 'webkitTransitionEnd' : 'transitionend';